module.exports = "/images/ill-piggy-bank.svg?0d8e5c57e05a8b29545cd2b028847944";